import { useEffect } from 'react';

const SITE = 'https://pillot.id';
const DEFAULT_IMAGE = '/og-image.jpg';

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute('content', content);
};

/** Per-page SEO + Open Graph tags (Google/Bing render JS; WhatsApp uses index.html defaults). */
export const useSeo = ({ title, description, image, path, type = 'website', lang = 'id' }) => {
  useEffect(() => {
    const origin = window.location.origin.includes('pillot.id') ? SITE : window.location.origin;
    const url = origin + (path || window.location.pathname);
    const img = (image || DEFAULT_IMAGE).startsWith('http') ? (image || DEFAULT_IMAGE) : origin + (image || DEFAULT_IMAGE);
    document.title = title;
    document.documentElement.lang = lang;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', img);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:site_name', 'Pillot');
    setMeta('property', 'og:locale', lang === 'en' ? 'en_US' : 'id_ID');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', img);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical); }
    canonical.setAttribute('href', url);
  }, [title, description, image, path, type, lang]);
};
